import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import { Spreadsheet } from '../../components/list/spreadsheet/classes'

export async function initSpreadsheets () {
  globalOnDemandVars.set_spreadsheetReady(false)

  const collection = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('Spreadsheets')
  const snapshot = await collection.get()

  const results = {}
  const setRowsFunctions = []
  snapshot.forEach((doc) => {
    const documentData = doc.data()
    results[doc.id] = new Spreadsheet(doc.id, documentData)

    const rowsCollection = collection.doc(doc.id).collection('Rows').orderBy('timeStamp')

    const setRows = async () => {
      const rowsSnapshot = await rowsCollection.get()

      const rows = []
      rowsSnapshot.forEach((rowDoc) => {
        const rowData = rowDoc.data()
        rows.push(rowData)
      })
      results[doc.id].setRows(rows)
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'spreadsheet rows init',
          preview: doc.id,
          value: {
            id: doc.id,
            rows,
            results
          }
          // , important: true
        })
      }
    }

    setRowsFunctions.push(setRows)
  })

  await Promise.all(setRowsFunctions.map((setRows) => (setRows())))

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'initSpreadsheets',
      value: {
        results
      }
      // , important: true
    })
  }

  globalOnDemandVars.set_spreadsheets(results)

  globalOnDemandVars.set_spreadsheetReady(true)
}
